import React, { useContext, useState, useEffect } from "react";
import SidePanel from "../side-panel";
import * as styles from "./styles.mod.scss";
import locale from "locales";
import GlobalContext from "services/global-context";
import { Formik } from "formik";
import TextInput from "../text-input";
import * as Yup from "yup";
import { customerRecover } from "services/shopify-account";

const LoginSchema = Yup.object().shape({ email: Yup.string().email().required(locale.login.invalidEmail) });

const Login = ({ wasOpened }) => {
  const [opened, setOpened] = useState(false);
  const [closing, setClosing] = useState(false);
  const { setCurrentPanel } = useContext(GlobalContext);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [submitText, setSubmitText] = useState("");

  const handleSubmit = ({ email }) => {
    setSubmitDisabled(true);

    customerRecover({ email }).then((response) => {
      console.log(response);
      setSubmitDisabled(true);
      if(response.errors?.length > 0 || response?.customerRecover?.customerUserErrors[0]?.code === "UNIDENTIFIED_CUSTOMER") {
        console.log("error");
        setSubmitText(response?.customerRecover?.customerUserErrors[0].message);
      } else {
        setSubmitText(locale.reset.submitText);
        setTimeout(() => {
          setCurrentPanel(null);
        }, 5000);
      }

    });
  };

  const handleLogin = () => {
    setCurrentPanel("login"); return false;
  };

  useEffect(() => {
    setTimeout(() => !closing && setOpened(true), 0);
  });

  const handleClose = () => {
    setClosing(true);
    setOpened(false);
    setTimeout(() => setCurrentPanel(null), 250);
  };

  const isOpen = () => opened || (!closing && wasOpened);
  
  return <SidePanel
    open={true}
    className={`${styles.sidePanel} ${isOpen() ? styles.opened : ""}`}
    bodyClass={styles.body}
    onClose={handleClose}
  >
    <h3 style={{ textAlign: "center" }}>{submitText}</h3>
    {!submitText && <>
      <h4 style={{ textAlign: "center" }}>{locale.reset.title}</h4>
      <p>{locale.reset.instructions}</p>
      <Formik
        initialValues={{ email: "" }}
        onSubmit={handleSubmit}
        validationSchema={LoginSchema}
      >
        {
          ({ errors, touched, handleChange, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className={styles.formInner}>
                <div className="row">
                  <div className="col-12">
                    <TextInput type="text" name="email" onChange={handleChange} placeholder={locale.login.email}  errors={errors.email} touched={touched.email} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <p className={styles.links}>
                      {locale.login.noAccount} <a href="#" onClick={handleLogin}>{locale.login.login}</a> <br/>
                    </p>
                  </div>
                </div>
              </div>
              <button type="submit" disabled={submitDisabled} className={styles.button}>{locale.reset.btn}</button>
            </form>
          )
        }
      </Formik>
    </>}

  </SidePanel>;
};

export default Login;
